<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<mat-sidenav-container
  [ngClass]="{
    cardBorder: options.cardBorder,
  }"
  [dir]="options.dir!">
  <router-outlet></router-outlet>
</mat-sidenav-container>
